"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3341],{

/***/ 33341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ EmbeddedBoardIframeComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/embedded-board/embedded-board.js + 1 modules
var embedded_board = __webpack_require__(94598);
// EXTERNAL MODULE: ./segments/desktop/core-components/embedded-board/default-props.js
var default_props = __webpack_require__(24459);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/embedded-board-iframe/embedded-board-iframe-component.scss.js


var StyledEmbeddedBoardIframeComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehjhcnq0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;align-items:center;flex-direction:column;.full-paragraph-wrapper{margin-bottom:80px;}.embedded-board-wrapper{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;}");

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/embedded-board-iframe/embedded-board-iframe-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var EmbeddedBoardIframeComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(EmbeddedBoardIframeComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(EmbeddedBoardIframeComponent);
    function EmbeddedBoardIframeComponent() {
        (0,_class_call_check/* default */.Z)(this, EmbeddedBoardIframeComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(EmbeddedBoardIframeComponent, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, fullParagraph = _this_props.fullParagraph, embeddedBoardHeight = _this_props.embeddedBoardHeight, embeddedBoardWidth = _this_props.embeddedBoardWidth, restProps = _object_without_properties(_this_props, [
                    "fullParagraph",
                    "embeddedBoardHeight",
                    "embeddedBoardWidth"
                ]);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEmbeddedBoardIframeComponent, {
                    className: "embedded-board-iframe-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "full-paragraph-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({}, fullParagraph))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "embedded-board-wrapper",
                            style: {
                                height: embeddedBoardHeight,
                                width: embeddedBoardWidth
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(embedded_board/* default */.Z, _object_spread({}, restProps))
                        })
                    ]
                });
            }
        }
    ]);
    return EmbeddedBoardIframeComponent;
}(react.PureComponent);

EmbeddedBoardIframeComponent.defaultProps = _object_spread_props(_object_spread({}, default_props/* default */.Z), {
    fullParagraph: _object_spread_props(_object_spread({}, full_paragraph/* default.defaultProps */.ZP.defaultProps), {
        title: "Get started with a board",
        body: "Drag and drop items, choose a status, add columns and items - everything is fully customizable to fit your workflow",
        textAlign: "center",
        topic: {}
    }),
    embeddedBoardHeight: "500px",
    embeddedBoardWidth: "80vw",
    paddingBottom: "64px"
});


/***/ })

}]);